export class Feedback {
    _id: string = '';
    uid: string ='';
    userName: string = '';
    feedbackType: string = '';
    suggestedOffer: string = '';
    suggestedOfferDetail: string = '';
    suggestedApp: string = '';
    otherSuggestion: string = '';
    status: boolean = false;
    reviewed: boolean = false;
    reviewComment: string = '';
    phoneNumber: string = '';
    submitTimeStamp: any;
}